<template>
  <div>
    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="date"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" @click="$emit('open')">
          <v-text-field
            v-model="dateRangeText"
            :label="label"
            filled
            readonly
            hint="Fra til dato legges inn"
            persistent-hint
          ></v-text-field>
        </span>
      </template>
      <v-date-picker
        v-model="date"
        no-title
        color="primary"
        range
        scrollable
        first-day-of-week="1"
        :min="min"
        @change="test"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="save(date)"> OK </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";
import notification from "@/helpers/notification";

export default Vue.extend({
  props: {
    label: {
      type: String,
      default: "Søk etter ledig rom",
    },
  },
  data: () => ({
    date: [] as any,
    modal: false,
    min: moment().format()
  }),
  methods: {
    test() {
      var fromDate = this.date[0];
      var toDate = this.date[1];
      if (moment(fromDate).isSame(toDate)) {
        this.date = [];
        notification.warn("Fra og til dato kan ikke være samme dag");
      } else if (moment(toDate).isBefore(fromDate)) {
        Vue.set(this.date, 0, toDate);
        Vue.set(this.date, 1, fromDate);
      }
    },
    save(date) {
      (this as any).$refs.dialog.save(date);
      this.$emit("save", date);
    },
    formatDate(date: string | null) {
      if (!date) return "";

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    formatRange(date: Array<string>) {
      if (date.length > 0) {
        var data = date.map((x) => {
          return (x = this.formatDate(x));
        });
        return data.join(" ~ ");
      }
      return "";
    },
  },
  computed: {
    dateRangeText(): string {
      return this.formatRange(this.date);
    },
  },
});
</script>
